<template>
    <v-card tile class="mb-6">
        <v-card-title class="bg-primary white--text" style="direction:flex;justify-content: space-between;">
            Display Logic
            <v-btn 
                v-if="currentDisplayLogic.conditional || currentDisplayLogic.operator"
                @click="$emit('update', { conditional: '', operator: '', questions: []})"
            >
                Clear
            </v-btn>
        </v-card-title>
        <v-card-text>
            <v-row>
                <v-col cols="12" md="6">
                <v-select
                    :items="conditionals"
                    v-model="currentDisplayLogic.conditional"
                    label="Conditional"
                    @change="$emit('update',{...currentDisplayLogic})"
                />
                </v-col>
                <v-col v-if="currentDisplayLogic.conditional !== 'always'" cols="12" md="4">
                <v-select
                    :items="logicalOperators"
                    v-model="currentDisplayLogic.operator"
                    label="Logical Operator"
                    @change="$emit('update',{...currentDisplayLogic})"
                />
                </v-col>
            </v-row>
            <v-row style="flex-direction: column;">
                <v-divider />

                <template v-if="showAddQuestion">
                    <v-btn
                        class="mx-16 my-4"
                        outlined
                        @click="addQuestion"
                    >
                        <v-icon>add</v-icon>
                        <span>Add Question</span>
                    </v-btn>

                    <v-divider />
                </template>

                <template v-for="(question, index) in currentDisplayLogic.questions">
                    <v-row :id="`question-row-${index}`">
                        <v-col
                            cols="6"
                            class="d-flex justify-center align-center"
                        >
                            <!-- Sets answer options when changed -->
                            <v-autocomplete
                                v-model="question.uid"
                                :label="'Question ' + (index + 1)"
                                :items="parsedQuestionList"
                                class="py-2 text-left solo-height-fix"
                                item-text="questionListTitle"
                                item-value="uid"
                                auto-select-first
                                solo
                                @change="getSelectedQuestionAnswers(question.uid, index)"
                            />
                        </v-col>
                        <v-col
                            v-if="showAnswerDropdown(question)"
                            cols="5"
                        >
                            <v-select
                                v-model="question.selection['answer']"
                                :label="'Answer'"
                                :items="question.options"
                                solo
                                class="py-2 text-left solo-height-fix"
                            />
                        </v-col>
                        <template v-if="question.type === 'number-input'">
                            <v-col cols="3">
                                <v-select
                                    v-model="question.selection.comparison"
                                    :label="'Comparison'"
                                    :items="question.options"
                                    solo
                                    class="py-2 text-left solo-height-fix"
                                />
                            </v-col>
                            <template  v-if="question.selection.comparison === 'greater-than'">
                                <v-col cols="2">
                                    <v-text-field
                                        v-model="question.selection.lowerLimit"
                                        type="number"
                                        label="Lower Limit"
                                        solo
                                        class="py-2 text-left solo-height-fix"
                                    />
                                </v-col>
                            </template>
                            <template v-if="question.selection.comparison === 'equal-to'">
                                <v-col cols="2">
                                    <v-text-field
                                        v-model="question.selection.equalTo"
                                        type="number"
                                        label="Equal To"
                                        solo
                                        class="py-2 text-left solo-height-fix"
                                    />
                                </v-col>
                            </template>
                            <template v-if="question.selection.comparison === 'less-than'">
                                <v-col cols="2">
                                    <v-text-field
                                        v-model="question.selection.upperLimit"
                                        type="number"
                                        label="Upper Limit"
                                        solo
                                        class="py-2 text-left solo-height-fix"
                                    />
                                </v-col>
                            </template>
                            <template  v-if="question.selection.comparison === 'between'">
                                <v-col cols="1">
                                    <v-text-field
                                        v-model="question.selection.lowerLimit"
                                        type="number"
                                        label="Lower Limit"
                                        solo
                                        class="py-2 text-left solo-height-fix"
                                    />
                                </v-col>
                                <v-col cols="1">
                                    <v-text-field
                                        v-model="question.selection.upperLimit"
                                        type="number"
                                        label="Upper Limit"
                                        solo
                                        class="py-2 text-left solo-height-fix"
                                    />
                                </v-col>
                            </template>
                        </template>
                        <template
                            v-if="question.type === 'multi-select' ||
                            (question.type === 'embedded-image' &&
                                question.interactionType === 'multi-select')
                            "
                        >
                            <v-col cols="4">
                            <v-select
                                v-model="question.selection.answer"
                                :label="'Answer'"
                                :items="question.options"
                                multiple
                                solo
                                class="pt-4 solo-height-fix"
                            />
                            </v-col>
                            <v-col cols="1">
                            <v-switch
                                v-model="question.selection.orLogic"
                                :label="question.selection.orLogic ? 'Any' : 'All'"
                            />
                            </v-col>
                        </template>
                        <v-col
                            cols="1"
                            class="d-flex align-center justify-center"
                        >
                            <v-btn
                            icon
                            class="mt-3"
                            @click="deleteQuestion(index)"
                            >
                            <v-icon>cancel</v-icon>
                            </v-btn>
                        </v-col>
                    </v-row>
                    <div
                        v-if="showCurrentOperator(index)"
                        class="d-flex justify-center align-center mt-4 mb-0"
                    >
                        <span class="pa-1 border-solid-1">{{
                            currentDisplayLogic.operator
                        }}</span>
                    </div>
                </template>              
            </v-row>
        </v-card-text>
    </v-card>    
</template>

<script>
import docDisplayLogic from '@/mixins/components/docDisplayLogic.mixin.js'

export default {
    name: 'DocDisplayLogic',

    mixins: [docDisplayLogic]
}
</script>

<style scoped>

</style>